// src/lib/portone.js
import * as PortOne from "@portone/browser-sdk/v2";

// 포트원 콘솔에서 확인한 값들 (테스트용)
const STORE_ID = process.env.REACT_APP_PORTONE_STORE_ID;
const CHANNEL_KEY = process.env.REACT_APP_PORTONE_CHANNEL_KEY;

export async function requestPortonePayment({ paymentId, orderName, amount }) {
    const response = await PortOne.requestPayment({
        storeId: STORE_ID,
        channelKey: CHANNEL_KEY,
        paymentId,              // 각 결제 요청 고유 ID
        orderName,              // 주문명
        totalAmount: amount,    // 결제 금액
        currency: "CURRENCY_KRW",
        payMethod: "EASY_PAY",
        easyPay: {
            easyPayProvider: "EASY_PAY_PROVIDER_KAKAOPAY"
        },
        customer: {
            phoneNumber: "01083680546"
        }
   
        // 1. 결제 수단을 '간편결제'로 변경
        // payMethod: "E_WALLET", 
        
        // // 2. 간편결제 서비스 중 '카카오페이'를 명시적으로 지정
        // easyPay: {
        //     provider: "KAKAOPAY",
        // },
    });

    return response;
}


export async function requestPortoneBillingKey({ issueId, issueName, customer }) {
    const response = await PortOne.requestIssueBillingKey({
        storeId: STORE_ID,
        channelKey: CHANNEL_KEY,
        billingKeyMethod: "CARD",   // 카드 빌링키 발급
        issueId,                    // 이 빌링 발급건의 고유 ID
        // issueName,                  // 결제창에 노출될 이름 ("핀즈 그로스 카드 등록" 등)
        // customer,                   // 고객 정보 (PG에 따라 필수 항목 다름)
    });
  
    return response;
}